import type { Maybe } from '@adornis/base/utilTypes.js';
import { TZDate } from '@date-fns/tz';
import { format } from 'date-fns';

export const berlinYearStart = (year: number): Date => new Date(new TZDate(year, 0, 1, 'Europe/Berlin').getTime());

export const activeYearStart = (now: Date): Date => berlinYearStart(new TZDate(now, 'Europe/Berlin').getFullYear());

export const formatAccountDate = (value: Maybe<Date | string>): string => {
  if (value === null || value === undefined || value === '') return '-';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '-' : format(new TZDate(date, 'Europe/Berlin'), 'dd.MM.yyyy, HH:mm');
};
